import { memo, useCallback } from "react"
import { Handle, Position } from "@xyflow/react"
import { getTeamColor } from "./teams"
import EditableLabel from "../EditableLabel"
import { useNodeContext } from "../NodeContext"

const DecisionNode = memo(({ id, data, selected }) => {
  const teamColor = getTeamColor(data.team)
  const { onLabelChange } = useNodeContext()

  const handleLabelSave = useCallback((newLabel) => {
    onLabelChange(id, newLabel)
  }, [id, onLabelChange])

  return (
    <div className={`decision-node ${selected ? "selected" : ""}`}>
      <Handle type="target" position={Position.Left} id="target-left" />
      <Handle type="target" position={Position.Top} id="target-top" />

      <div className="diamond">
        <EditableLabel
          value={data.label}
          onSave={handleLabelSave}
          className="node-label"
        />
      </div>

      {teamColor && (
        <div className="team-badge" style={{ backgroundColor: teamColor }} />
      )}

      <Handle type="source" position={Position.Top} id="yes" />
      <Handle type="source" position={Position.Bottom} id="no" />
      <Handle type="source" position={Position.Right} id="right" />
    </div>
  )
})

DecisionNode.displayName = "DecisionNode"

export default DecisionNode
